import React, { Component } from "react";
import { Table, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

// utils
import { update } from "../../../utils/apiService";

// actions
import { updateVideo } from "../../../actions/index";

class UsersToExcludeTable extends Component {
  constructor() {
    super();

    this.deleteUser = this.deleteUser.bind(this);
  }
  deleteUser(userToExclude) {
    let { video, updateVideo } = this.props;
    let usersToExclude = this.props.video.users_to_exclude;
    let newUsersToExclude = usersToExclude.filter(user => {
      return user !== userToExclude;
    });
    let url = `/campaigns/${video.campaign_id}/videos/${video.id}`;
    let data = {
      video: {
        users_to_exclude: newUsersToExclude
      }
    };
    update(url, data)
      .then(res => {
        let updatedVideo = res.data;
        updateVideo(video.campaign_id, updatedVideo);
        toastr.success("User removido com sucesso!");
      })
      .catch(err => {
        toastr.error("Ocorreu um erro. Tente novamente.");
      });
  }
  render() {
    const { video } = this.props;
    return (
      <Table bordered striped>
        <thead>
          <tr>
            <th>Nome</th>
            <th width={10} />
          </tr>
        </thead>
        <tbody>
          {video.users_to_exclude !== null &&
            video.users_to_exclude.map(user => (
              <tr key={user}>
                <td>{user}</td>
                <td>
                  <Button onClick={() => this.deleteUser(user)}>Excluir</Button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateVideo: (campaignId, video) => {
      dispatch(updateVideo(campaignId, video));
    }
  };
};

export default connect(null, mapDispatchToProps)(UsersToExcludeTable);



// WEBPACK FOOTER //
// ./src/components/pages/UsersToExclude/UsersToExcludeTable.js